import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ClickOutside from './ClickOutside';
import Container from './Container';
import Popup from './Popup';
import Text from './Text';

const arrowPositionCss = value => {
  return {
    topLeft: 'top: 0px; left: 0px; margin-left: 25px;',
    top: 'top: 0px; left: 50%;',
    topRight: 'top: 0px; left: 100%; margin-left: -25px;',
    rightTop: 'top:0%; left:100%; margin-top: 25px;',
    right: 'top:50%; left:100%',
    rightBottom: 'top:100%; left:100%; margin-top: -25px;',
    bottomRight: 'top: 100%; left: 100%; margin-left: -25px;',
    bottom: 'top: 100%; left: 50%;',
    bottomLeft: 'top: 100%; left: 0px; margin-left: 25px;',
    leftTop: 'top:0%; left:0px; margin-top: 25px;',
    left: 'top:50%; left:0px;',
    leftBottom: 'top:100%; left:0px; margin-top: -25px;',
  }[value || 'topLeft'];
};

const StyledLink = styled.a`
  font-weight: normal;
  cursor: pointer;
`;

const StyledPopup = styled(Popup)`
  margin: 0px;
  top: 0px;
  left: 0px;
  border: 1px solid ${props => props.theme.border.border300};
  ${props => props.popupStyles(props)}
`;

const Arrow = styled(Container)`
  position: absolute;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%) rotate(45deg);
  background-color: ${props => props.theme.background.background100};
  box-shadow: ${props => props.theme.shadow.popup};
  border: 1px solid ${props => props.theme.border.border300};
  z-index: -1;
  ${props => arrowPositionCss(props.position)}
`;

const StyledContainer = styled(Container)`
  position: relative;
  background-color: ${props => props.theme.background.background100};
  border-radius: 11px;
  z-index: 1;
`;

const ToolTip = ({
  children,
  message,
  anchor,
  arrowPosition,
  popupWidth,
  popupMinWidth,
  popupStyles,
  showArrow,
  ...props
}) => {
  const [show, setShow] = useState();

  return (
    <ClickOutside onClickOutside={() => setShow(false)} {...props}>
      <StyledLink onClick={() => setShow(!show)}>{children}</StyledLink>
      <StyledPopup
        show={show}
        anchor={anchor}
        width={popupWidth}
        minWidth={popupMinWidth}
        popupStyles={popupStyles}
      >
        {showArrow && <Arrow position={arrowPosition} />}
        <StyledContainer>
          {typeof message === 'string' ? (
            <Container
              padding="16px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Text>{message}</Text>
            </Container>
          ) : (
            message
          )}
        </StyledContainer>
      </StyledPopup>
    </ClickOutside>
  );
};

ToolTip.propTypes = {
  children: PropTypes.node,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  anchor: PropTypes.oneOf([
    'topLeft',
    'top',
    'topRight',
    'rightTop',
    'right',
    'rightBottom',
    'bottomLeft',
    'bottom',
    'bottomRight',
    'leftBottom',
    'left',
    'leftTop',
  ]),
  arrowPosition: PropTypes.oneOf([
    'topLeft',
    'top',
    'topRight',
    'rightTop',
    'right',
    'rightBottom',
    'bottomLeft',
    'bottom',
    'bottomRight',
    'leftBottom',
    'left',
    'leftTop',
  ]),
  popupWidth: PropTypes.string,
  popupMinWidth: PropTypes.string,
  popupStyles: PropTypes.func,
  showArrow: PropTypes.bool,
};

ToolTip.defaultProps = {
  children: null,
  message: null,
  anchor: null,
  arrowPosition: null,
  popupWidth: null,
  popupMinWidth: null,
  popupStyles: () => {},
  showArrow: true,
};

export default ToolTip;
